import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import RseeDiscountsList from './List/index';
import ShowForPermission from '../../components/ShowForPermission';
import ENUMS from '../../enums';
import Spin from '../../components/loading';
import * as rseeDiscountsActions from '../../redux/rseeDiscounts/actions';
import RseeDiscountsFilter from './rseeDiscountsFilter';
import submitForm from '../../utils/submitForm';

const RseeDiscounts = props => {
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [mainCafeIds, setCafeIds] = useState([]);
  const [mainQuery, setQuery] = useState('');
  const [sortType, setSortType] = useState('desc');
  const [sort, setSort] = useState('');
  const [filter, setFilter] = useState('');
  const sortBy = 'lastUpdatedAt';

  useEffect(() => {
    const query = buildSearchQuery(currentPage, itemsPerPage);
    props.getMyRseeDiscountsList(query);
    // sortTable(sortBy);
  }, []);

  useEffect(() => {
    filterAndSort();
  }, [filter]);

  useEffect(() => {
    let searchQuery = buildSearchQuery(currentPage, itemsPerPage);
    props.getMyRseeDiscountsList(searchQuery);
  }, [mainQuery]);

  const applyFilters = event => {
    const filter = submitForm(event, [], [], mainCafeIds);
    setCurrentPage(1);
    setFilter(filter);
  };

  const onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    setCurrentPage(currentPage);
    const query = buildSearchQuery(currentPage, itemsPerPage);
    props.getMyRseeDiscountsList(query);
  };

  const buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${mainQuery || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  const filterAndSort = () => {
    let query;
    if (sort && filter) {
      query = `${filter}&${sort}`;
    } else if (filter) {
      query = `${filter}`;
    } else if (sort) {
      query = `${sort}`;
    }

    setQuery(query);
    setCurrentPage(1);
  };

  const onSelectCafeIds = cafeIds => setCafeIds(cafeIds ? [...cafeIds] : [cafeIds]);

  const sortTable = query => {
    setSortType(sortType === 'asc' ? 'desc' : 'asc');
    query = `${query}-${sortType}`;
    setSort(`sort=${query}`);
    filterAndSort();
  };

  return (
    <Spin spinning={props.getMyRseeDiscountsListLoading}>
      <section className="page-header">
        <h1>{locales('titles.manage.my.rsee.discounts')}</h1>
        <div className="form-actions">
          <ShowForPermission permission={ENUMS.PERMISSIONS.values.ADD_NEW_RSEE_DISCOUNT}>
            <Link to="/rsee-discounts/create" className="btn btn-success">
              <i className="fa fa-plus"></i>
              {locales('titles.add.new.rsee.discount')}
            </Link>
          </ShowForPermission>
        </div>
      </section>
      <section className="panel panel-default">
        <div className="panel-heading">
          <h3 className="panel-title">
            <i className="fa fa-pencil"></i>
            {locales('titles.my.rsee.discounts.list')}
          </h3>
        </div>
        <div className="panel-body">
          <RseeDiscountsFilter
            applyFilters={applyFilters}
            filterAndSort={filterAndSort}
            onSelectCafeIds={onSelectCafeIds}
            pageNumber={currentPage}
          />
          <RseeDiscountsList
            myRseeDiscountsList={props.myRseeDiscountsList}
            pageNumber={currentPage}
            pageSize={pageSize}
            sortTable={sortTable}
            totalRecords={props.totalRecords}
            onPageChange={onPageChanged}
            sortType={sortType}
            buildSearchQuery={buildSearchQuery}
          />
        </div>
      </section>
    </Spin>
  );
};

const mapStateToProps = state => {
  return {
    getMyRseeDiscountsListLoading: state.rseeDiscountsReducer.getMyRseeDiscountsListLoading,
    getMyRseeDiscountsListFailed: state.rseeDiscountsReducer.getMyRseeDiscountsListFailed,
    getMyRseeDiscountsListError: state.rseeDiscountsReducer.getMyRseeDiscountsListError,
    getMyRseeDiscountsListMessage: state.rseeDiscountsReducer.getMyRseeDiscountsListMessage,
    myRseeDiscountsList: state.rseeDiscountsReducer.myRseeDiscountsList,
    totalRecords: state.rseeDiscountsReducer.myRseeDiscountsListTotalRecords
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getMyRseeDiscountsList: query => dispatch(rseeDiscountsActions.getMyRseeDiscountsList(query))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RseeDiscounts);
